module.exports = __webpack_public_path__ + "img/avatar_3.3591628a.png";